import { h, Component } from 'preact';
import { parseUri } from '../../../shared/actions/http';
//import FetchState from './ui/FetchState';
import Loading from '../ui/Loading';
import store from '../../store';
import * as oauthActions from '../../actions/oauth';
import { userType } from '../../../includecart/propTypes';
import AppLayout from '../layouts/AppLayout';

class AuthStripe extends Component {
  constructor() {
    super();

    this.state = {
      result: { success: null, message: null },
    };
  }

  doStripeVerify() {
    let urlParts = parseUri(window.location.href);

    oauthActions.remote.linkStripeAccount(urlParts.queryKey.code, urlParts.queryKey.state)
      .then(result => {
        this.setState({ result });
        console.log('[AuthStripe] RESULT =', result);
      })
      .catch(err => {
        this.setState({ result: { success: false, message: err.message } });
        console.error(err);
      });
  }

  render() {
    let { result } = this.state;
    let urlParts = parseUri(window.location.href);
    let siteId = urlParts.queryKey.state ? urlParts.queryKey.state.split('_')[0] : false;

    // Perform lookup automatically the first time
    if (result.success === null) {
      this.doStripeVerify();
    }

    return (
      <AppLayout title="Verifying Stripe Link...">
        <div data-component="AuthStripe" className="card">
          <div className="content-padded">
            {result.success === null ? <Loading /> : null}
            {result.success === false ? <h2>Error!</h2> : null}
            {result.success === true ? <h2>Succcess!</h2> : null}
            <p>{result.message}</p>
            <p><a href={'/account/sites/' + siteId}> Back to Site</a></p>
          </div>
        </div>
      </AppLayout>
    );
  }
}

AuthStripe.propTypes = {
  user: userType.isRequired,
};

export default store.connect(AuthStripe, {
  user: 'user',
});
